<template>
  <section id="integraciones">
    <div class="wrap">
      <div class="section-head">
        <div class="left">
          <span class="eyebrow"><span class="dot"></span>{{ labelsState['lv_integrations_eyebrow'] || 'Integrations' }}</span>
          <h2>{{ labelsState['lv_integrations_heading_pre'] || 'Connect with' }} <span class="grad-text">{{ labelsState['lv_integrations_heading_grad'] || 'the tools' }}</span> {{ labelsState['lv_integrations_heading_post'] || 'you already use.' }}</h2>
        </div>
        <div class="right">{{ labelsState['lv_integrations_desc'] || '12+ native integrations and an open API. Webhooks, n8n and Zapier for everything else.' }}</div>
      </div>
      <div class="integrations">
        <div v-for="it in integrations" :key="it.name" class="integration">
          <div class="int-badge">
            <img
              v-if="it.domain"
              :src="brandIcon(it.domain)"
              :alt="it.name"
              class="brand-icon"
              @error="onImgError($event, it)"
            />
            <span v-else class="badge-text">{{ it.short }}</span>
          </div>
          <span class="int-label">{{ it.name }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useLabelsStore } from '@/stores/labels';
import { useLanguageStore } from '@/stores/language';

const CLIENT_ID = '1idtZELcktsTTUyKkcX';

export default {
  name: 'IntegrationsV2',
  setup() {
    const labelsStore = useLabelsStore();
    const languageStore = useLanguageStore();
    onMounted(() => labelsStore.fetchAndSetLabels(languageStore.language));
    return { labelsState: computed(() => labelsStore.labels) };
  },
  data() {
    return {
      integrations: [
        { name: 'WhatsApp',     domain: 'whatsapp.com' },
        { name: 'Instagram',    domain: 'instagram.com' },
        { name: 'Messenger',    domain: 'messenger.com' },
        { name: 'TikTok',       domain: 'tiktok.com' },
        { name: 'Web Chat',     domain: null, short: 'Wc' },
        { name: 'Email',        domain: null, short: '@' },
        { name: 'Shopify',      domain: 'shopify.com' },
        { name: 'Twilio',       domain: 'twilio.com' },
        { name: 'Coordinadora', domain: 'coordinadora.com' },
        { name: 'Stripe',       domain: 'stripe.com' },
        { name: 'Mercado Pago', domain: 'mercadopago.com' },
        { name: 'Google Sheets',domain: 'sheets.google.com' },
      ],
    };
  },
  methods: {
    brandIcon(domain) {
      return `https://cdn.brandfetch.io/${domain}/w/400/h/400/icon?c=${CLIENT_ID}`;
    },
    onImgError(e, item) {
      e.target.style.display = 'none';
      const parent = e.target.parentNode;
      const span = document.createElement('span');
      span.className = 'badge-text';
      span.textContent = item.short || item.name.slice(0, 2).toUpperCase();
      parent.appendChild(span);
    },
  },
};
</script>

<style scoped>
.int-badge {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.2);
  overflow: hidden;
  flex-shrink: 0;
}

.brand-icon {
  width: 48px;
  height: 48px;
  object-fit: contain;
  display: block;
}

.badge-text {
  font-size: 18px;
  font-weight: 700;
  color: #334155;
  font-family: var(--f-display, sans-serif);
  line-height: 1;
}

.int-label {
  font-size: 12px;
  color: #c4cce6 !important;
  font-weight: 500;
  text-align: center;
  margin-top: 2px;
  line-height: 1.3;
}
</style>
